import { APP, WS_DATA } from './app.constants';

export const SUPPORT = `${APP}_support`;
export const WS_DATA_SUPPORT = `${WS_DATA}/support`;

export const GET_SUPPORT_TICKETS = `${SUPPORT}/GET_SUPPORT_TICKETS`;
export const SUPPORT_TICKETS_CHANGED = `${SUPPORT}/SUPPORT_TICKETS_CHANGED`;
export const SET_LOADING = `${SUPPORT}/SET_LOADING`;
export const SET_ERROR = `${SUPPORT}/SET_ERROR`;
